import { COLUMN_END_DATE, COLUMN_NAME, COLUMN_SITE, COLUMN_START_DATE } from "../../constants/column-types";
import { FILTER_SITES } from "../../constants/filter-types";
import { TableColumn } from "../table/TableColumn";

const HolidayColumns: TableColumn[] = [
    {
        heading: "Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        sortByName: "holName",
        sortDirection: "asc",
        active: true,
        translationKey: "name",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Start Date",
        accessor: "startDate",
        isNumeric: false,
        id: 1,
        sortByName: "holDateStart",
        sortDirection: "asc",
        active: true,
        translationKey: "startDate",
        columnId: COLUMN_START_DATE,
    },
    {
        heading: "End Date",
        accessor: "endDate",
        isNumeric: false,
        id: 2,
        sortByName: "holDateEnd",
        sortDirection: "asc",
        active: true,
        translationKey: "endDate",
        columnId: COLUMN_END_DATE,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 3,
        sortByName: "site.siteName",
        sortDirection: "asc",
        active: true,
        searchOnName: "site.id",
        lookupName: "site.siteName",
        translationKey: "site",
        columnId: COLUMN_SITE,
        filterId: FILTER_SITES,
        settingDataName: 'site'
    }
];

export default HolidayColumns;
